// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"08adc0fe","485":"528fe6a0","673":"13e2598d"}[chunkId] + ".chunk.js";
};